import Vue from 'vue'
import AppHeader from '@/components/Header'
import VueMultiselect from 'vue-multiselect'
import { Fragment } from 'vue-fragment'

Vue.component('app-header', AppHeader)
Vue.component('multiselect', VueMultiselect)
Vue.component('fragment', Fragment)
